import { configureStore } from '@reduxjs/toolkit';

import { requestsSlice } from '../assistant/request';
import { notificationsSlice } from '../assistant/notifications';
import { hudSlice } from '../assistant/hud';
import { historySlice } from '../assistant/history';
import { claimSlice } from '../assistant/claim';
import { queueSlice } from '../assistant/queue';

import { toasterSlice } from '../ui';

const reducer = {
	requests: requestsSlice,
	notifications: notificationsSlice,
	hud: hudSlice,
	history: historySlice,
	claim: claimSlice,
	toaster: toasterSlice,
	queue: queueSlice
};

export default configureStore({
	reducer: reducer
});




